var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.orders.length > 0)?_c('b-badge',{attrs:{"variant":"danger"},on:{"update-orders":_vm.getOrders}},[_vm._v(" "+_vm._s(_vm.orders.length))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }